import { unwrapResult } from '@reduxjs/toolkit'
import MUIDataTable from 'mui-datatables'
import React, { useEffect } from 'react'
import { Typography, makeStyles, IconButton } from '@material-ui/core'
import EditIcon from '@material-ui/icons/Edit'
import DeleteIcon from '@material-ui/icons/Delete'

import { useActionRunner } from 'src/modules/notification'
import { Button, Container, FormikDialog } from 'src/modules/ui'

import { useAdmin } from '../hooks'
import { AddRolesModal, EditRolesModal } from './RolesModal'

const useStyles = makeStyles(theme => ({
  addButton: {
    marginLeft: theme.spacing(2),
  },
  columnButton: {
    margin: theme.spacing(0.5),
  },
}))

const Roles = () => {
  const classes = useStyles()
  const { fetchPermissions, deleteRoles, fetchRoles, roles } = useAdmin()
  const [fetchData] = useActionRunner([fetchPermissions, fetchRoles])

  useEffect(() => {
    fetchData()
  }, [])

  // datatable columns
  const columns = [
    {
      name: 'name',
      label: 'Name',
      options: {
        filter: false,
        sort: true,
      },
    },
    {
      name: 'description',
      label: 'Description',
      options: {
        filter: false,
        sort: true,
      },
    },
    {
      name: 'id',
      label: ' ',
      options: {
        filter: false,
        sort: true,
        customBodyRender: roleId => {
          return (
            <>
              <EditRolesModal
                role={roles.find(r => r.id === roleId)}
                trigger={props => (
                  <IconButton
                    {...props}
                    color="primary"
                    size="small"
                    className={classes.columnButton}
                  >
                    <EditIcon />
                  </IconButton>
                )}
              />

              <FormikDialog
                successNotification={{
                  image: 'mushrooms',
                  message: 'Role deleted',
                }}
                errorNotification={result => {
                  try {
                    unwrapResult(result)
                  } catch (error) {
                    return error.status === 405
                      ? "Can't delete role as one or more users are associated with it"
                      : undefined
                  }
                }}
                initialValues={{}}
                onSubmit={() => deleteRoles(roleId)}
                submitColor="darkRed"
                submitText="Delete Role"
                trigger={props => (
                  <IconButton
                    size="small"
                    color="primary"
                    className={classes.columnButton}
                    {...props}
                  >
                    <DeleteIcon />
                  </IconButton>
                )}
              >
                <Typography>
                  Are you sure you want to delete this role?
                </Typography>
              </FormikDialog>
            </>
          )
        },
      },
    },
  ]
  //  datatable options
  const options = {
    download: false,
    elevation: 0,
    print: false,
    responsive: 'simple',
    rowsPerPage: 20,
    rowsPerPageOptions: [20, 50, 100],
    rowHover: false,
    selectableRows: 'none',
    viewColumns: false,
    customToolbar: props => (
      <AddRolesModal
        trigger={props => (
          <Button {...props} color="lightGreen" className={classes.addButton}>
            Add
          </Button>
        )}
      />
    ),
  }

  return (
    <Container muiTable>
      <MUIDataTable
        title={'Roles'}
        data={roles}
        columns={columns}
        options={options}
      />
    </Container>
  )
}

export default Roles
